export default __webpack_public_path__ + "static/B01-843097379c9640899430ee35e3e3247c.png";